export enum SurveyResultsFilterNames {
	roundId = 'roundId',
	serviceId = 'serviceId',
	roleId = 'roleId',
	businessUnit = 'businessUnit',
	region = 'region',
	city = 'city',
	country = 'country',
	office = 'office',
}

export interface IResultLocationFilter {
	[SurveyResultsFilterNames.region]?: string;
	[SurveyResultsFilterNames.country]?: string;
	[SurveyResultsFilterNames.city]?: string;
	[SurveyResultsFilterNames.office]?: string;
}

export interface ISurveyResultsFilter extends IResultLocationFilter {
	[SurveyResultsFilterNames.roundId]?: string;
	[SurveyResultsFilterNames.serviceId]?: string;
	[SurveyResultsFilterNames.roleId]?: number;
	[SurveyResultsFilterNames.businessUnit]?: string;
}
